import React, { useEffect, useState } from "react";
import MonthRangePicker from "../../../components/MonthRangePicker";
import { useSelector, useDispatch } from 'react-redux';
import { updateCareerInformation, getTalentDetail, getCareerInformation } from "../../../reducers/talentMypage";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { LoadingSpinner } from './../../../components/Icons'
import CustomIconButton from "../../../components/CustomIconButton";
import CheckboxButton from "../../../components/CheckboxButton";
import TextInput from "../../../components/TextInput";
import CustomButton from "../../../components/CustomButton";
interface CareerProps {
    onClose: () => void;
}

interface CareerItem {
    description: string;
    join_date: string;
    leave_date: string;
    is_current: boolean;
}


const Career: React.FC<CareerProps> = ({ onClose }) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const currentUser = useSelector((state: any) => state.currentUser)
    const talentMypage = useSelector((state: any) => state.talentMypage)
    const careerData = talentMypage?.careerData
    const { isLoading } = useSelector((state: any) => state.talentMypage)
    const { id } = currentUser.talentInfo
    const [dataCareer, setDataCareer] = React.useState<CareerItem[]>([]);
    const [isEditing, setIsEditing] = useState(false)
    const [errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
        dispatch(getCareerInformation())
    }, []);

    useEffect(() => {
        if (careerData) {
            setDataCareer(careerData);
        }
    }, [careerData])

    const handleSubmit = (e: any) => {
        e.preventDefault();
    };

    const removeCareerItem = (idx: any) => {
        const newDataCareer = dataCareer.filter((_, index) => index !== idx);
        setDataCareer(newDataCareer);

        setErrorMessage("");
        setIsEditing(true)
        if(newDataCareer.length == 0) {
            return
        }

        for (const item of newDataCareer) {
            if (!item.description || !item.join_date|| (!item.is_current && !item.leave_date)) {
                setErrorMessage('職場、入社日、退社日が必須です。');
                return false;
            }
        }

        if (newDataCareer.filter(item => item.is_current).length > 1) {
            setErrorMessage('現職が存在しています。');
            return false;
        }

        const seen = new Set();
        for (const item of newDataCareer) {
            const { description, join_date, leave_date } = item;
            const leaveDateFormatted = leave_date ? leave_date.substring(0, 7) : "";
            const key = JSON.stringify({ description, join_date, leave_date: leaveDateFormatted });
            if (seen.has(key)) {
                setErrorMessage("重複しています。");
                return false;
            }
            seen.add(key);
        }
    }

    const saveCareer = () => {
        setErrorMessage("")
        const dataForm = {
            formData: {
                career: JSON.stringify(dataCareer),
            },
        }

        for (const item of dataCareer) {
            if (!item.description || !item.join_date|| (!item.is_current && !item.leave_date)) {
                setErrorMessage('職場、入社日、退社日が必須です。');
                return false;
            }
        }

        if (dataCareer.filter(item => item.is_current).length > 1) {
            setErrorMessage('現職が存在しています。');
            return false;
        }

        const seen = new Set();
        for (const item of dataCareer) {
            const { description, join_date, leave_date } = item;
            const leaveDateFormatted = leave_date ? leave_date.substring(0, 7) : "";
            const key = JSON.stringify({ description, join_date, leave_date: leaveDateFormatted });
            if (seen.has(key)) {
                setErrorMessage("重複しています。");
                return false;
            }
            seen.add(key);
        }

        dispatch(updateCareerInformation(dataForm))
        setIsEditing(false)
        onClose();
    };

    const handleAddOtherCareer = () => {
        const newCareer = { id: null, talent_id: null, description: "", join_date: "", leave_date: "", is_current: false }
        setDataCareer((prevDataCareer: any) => [...prevDataCareer, newCareer]);
        setIsEditing(true)
    }

    return (
        <div className="w-[392px] max-w-full h-full bg-white rounded-2xl pt-3 alu-panel-box-shadow flex flex-col">
            <div className="flex items-start justify-between gap-2 px-4 mb-1">
                <div>
                    <h2 className="text-xl leading-[1.875rem] font-bold alu-text-base-2">キャリアの編集</h2>
                    <p className="text-sm alu-text-base-1">キャリアは在籍期間によって自動で並び替えられます。</p>
                </div>
                <CustomIconButton onClick={onClose} customStyle="shrink-0">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_8574_265)">
                        <path
                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                            fill="currentColor"
                        />
                        </g>
                        <defs>
                        <clipPath id="clip0_8574_265">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                        </defs>
                    </svg>
                </CustomIconButton>
            </div>
            <div className="overflow-y-auto custom-scrollbar flex-1 px-4 pb-4">
                <form onSubmit={handleSubmit} className="mt-6 w-full flex flex-col">

                    {/* {isEditing && ( */}
                    {(Array.isArray(dataCareer)) && dataCareer.map((item: any, idx: any) => (
                        <div className="flex items-center justify-between gap-[0.625rem] mb-4" key={idx}>
                            <div className="flex-1">
                                <div className="flex gap-2 pb-4 border-b alu-border">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <mask id="mask0_13284_8851" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                            <rect width="24" height="24" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_13284_8851)">
                                            <path d="M8 10C8 11.1 8.39167 12.0417 9.175 12.825C9.95833 13.6083 10.9 14 12 14C13.1 14 14.0417 13.6083 14.825 12.825C15.6083 12.0417 16 11.1 16 10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10ZM6 10C6 8.33333 6.58333 6.91667 7.75 5.75C8.91667 4.58333 10.3333 4 12 4C13.6667 4 15.0833 4.58333 16.25 5.75C17.4167 6.91667 18 8.33333 18 10C18 11.5 17.525 12.8042 16.575 13.9125C15.625 15.0208 14.4333 15.6917 13 15.925C13 15.925 12.3905 16 12 16C11.6095 16 11 15.925 11 15.925C9.56667 15.6917 8.375 15.0208 7.425 13.9125C6.475 12.8042 6 11.5 6 10Z" fill="#808080" />
                                            <path d="M11 17H13V19H11V17Z" fill="#808080" />
                                            <path d="M11 20H13V22H11V20Z" fill="#808080" />
                                        </g>
                                    </svg>
                                    <div className="w-full flex flex-col gap-2">
                                        <TextInput
                                            size="md"
                                            name="career[description][]"
                                            placeholder="職場"
                                            value={item.description}
                                            onChange={(e:any) => {
                                                setDataCareer((prev) => prev.map((careerItem, careerIdx) =>
                                                    careerIdx === idx
                                                        ? { ...careerItem, description: e.target.value }
                                                        : careerItem
                                                ))
                                                setIsEditing(true)
                                            }
                                            }
                                        />

                                        <div className="w-full">
                                            <MonthRangePicker
                                                type={3}
                                                startMonth={item.join_date}
                                                endMonth={item?.leave_date ? item?.leave_date : ''}
                                                onChange={(start: string, end: string) => {
                                                    setDataCareer((prev) => prev.map((careerItem, careerIdx) =>
                                                        careerIdx === idx
                                                            ? { ...careerItem, join_date: start, leave_date: end }
                                                            : careerItem
                                                    ))
                                                    setIsEditing(true)
                                                }}
                                            />
                                        </div>
                                        <div className="flex gap-2 items-center">
                                        <CheckboxButton
                                            id={"careerChecked" + idx}
                                            name="career[checked][]"
                                            value={item.is_current}
                                            label={"現職"}
                                            onChange={(e:any) => {
                                            let leaveDateToCurrent;
                                            setDataCareer((prev) =>
                                                prev.map((careerItem, careerIdx) =>{
                                                    if(careerIdx === idx) {
                                                    leaveDateToCurrent = !careerItem.is_current;
                                                    return {
                                                        ...careerItem,
                                                        is_current: !careerItem.is_current,
                                                    }
                                                    } else return careerItem
                                                }
                                                )
                                            );
                                            setIsEditing(true)
                                            }
                                            }
                                        />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <CustomIconButton
                            customStyle="shrink-0 self-start"
                            onClick={() => removeCareerItem(idx)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M200-440v-80h560v80H200Z"/></svg>
                            </CustomIconButton>
                        </div>
                    ))}
                    {errorMessage && <p className="alu-text-error text-sm mt-1 mb-3">※{errorMessage}</p>}
                    <div className="mb-10">
                        <button type="button" className="flex items-center gap-1 p-1 rounded hover:bg-[#FFF3E5]" onClick={handleAddOtherCareer}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clipPath="url(#clip0_13284_8548)">
                                    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#FF861A" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_13284_8548">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span className="alu-text-title text-sm">その他のキャリアを追加</span>
                        </button>
                    </div>
                    <div className="flex items-center justify-between gap-4">
                        <CustomButton
                            type="button"
                            onClick={() => onClose()}
                            width="full"
                            variant="outline"
                            size="md"
                        >
                            キャンセル
                        </CustomButton>
                        <CustomButton
                            type="button"
                            onClick={() => saveCareer()}
                            disabled={isLoading || !isEditing}
                            width="full"
                            size="md"
                        >
                            <p>{isLoading ? "保存中..." : "保存"}</p>
                            {isLoading && (
                                <span><LoadingSpinner /></span>
                            )}
                        </CustomButton>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Career;
